import { useEffect, useState } from "react";
import { api__getIsWorkingTime_depricated } from "@/apis/contact/working-hours";
import { checkTestFlag } from "@/common/config/websiteConfig";
var CACHE_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds

var _storeToWindow = function _storeToWindow(val) {
  window.is_working_time = val;
  window.is_working_time_timeout = setTimeout(function () {
    delete window.is_working_time;
  }, CACHE_DURATION);
};
var useIsWorkingTime = function useIsWorkingTime() {
  var TEST_IS_WORKING_HOUR = checkTestFlag("TEST_IS_WORKING_HOUR");
  if (TEST_IS_WORKING_HOUR !== undefined) {
    return TEST_IS_WORKING_HOUR;
  }
  var _useState = useState(true),
    is_working_time = _useState[0],
    setWorkingTime = _useState[1];
  useEffect(function () {
    // If there is already a cached value, use it
    if (window.is_working_time !== undefined) {
      setWorkingTime(window.is_working_time);
    } else {
      // Fetch data if no cache exists
      api__getIsWorkingTime_depricated().then(function (results) {
        setWorkingTime(results);
        _storeToWindow(results);
      });
    }
  }, []);
  return is_working_time;
};
export default useIsWorkingTime;